/* eslint-disable */
import { rootApi } from '../rootApi';

export const dealerAgreementTypeApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllDealerAgreementType: builder.query({
            query: ({ dealerId, dealerAddressBrandId, pageNumber = 1, pageSize = 10 }) => ({
                url: 'v1/dealeragreementtype/getall',
                method: 'GET',
                params: {
                    DealerId: dealerId,
                    ...(dealerAddressBrandId ? { DealerAddressBrandId: dealerAddressBrandId } : {}),
                    PageNumber: pageNumber,
                    PageSize: pageSize
                }
            }),
            transformResponse: (response) => {
                if (response?.data?.items) {
                    return {
                        items: response.data.items,
                        count: response.data.totalCount || 0
                    };
                }
                return { items: [], count: 0 };
            },
            providesTags: ['DealerAgreementType']
        }),

        getByIdDealerAgreementType: builder.query({
            query: (id) => ({
                url: 'v1/dealeragreementtype/getbyid',
                method: 'GET',
                params: { Id: id }
            }),
            transformResponse: (response) => {
                if (response?.data) {
                    return response.data;
                }
                return {};
            },
            providesTags: (result, error, id) => [{ type: 'DealerAgreementType', id }]
        }),

        createDealerAgreementType: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeragreementtype/add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, arg) => ['DealerAgreementType', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        updateDealerAgreementType: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeragreementtype/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, arg) => ['DealerAgreementType', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        deleteDealerAgreementType: builder.mutation({
            // Birleşik onay akışı için delete komutuna dealerAddressBrandId (anchor) eklendi.
            // Geriye dönük uyumluluk: hem sayısal id hem { id, dealerAddressBrandId } kabul edilir.
            query: (arg) => {
                const { id, dealerAddressBrandId } = typeof arg === 'object' && arg !== null ? arg : { id: arg };
                return {
                    url: 'v1/dealeragreementtype/delete',
                    method: 'POST',
                    body: { id, dealerAddressBrandId }
                };
            },
            invalidatesTags: (result, error, arg) => ['DealerAgreementType', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),
        getCurrencyByDealerAddressId: builder.query({
            query: (dealerAddressId) => ({
                url: 'v1/dealeragreementtype/getcurrencybydealeraddressid',
                method: 'GET',
                params: { DealerAddressId: dealerAddressId }
            }),
            transformResponse: (response) => response?.data?.currency ?? null
        })
    })
});

export const {
    useGetAllDealerAgreementTypeQuery,
    useGetByIdDealerAgreementTypeQuery,
    useCreateDealerAgreementTypeMutation,
    useUpdateDealerAgreementTypeMutation,
    useDeleteDealerAgreementTypeMutation,
    useGetCurrencyByDealerAddressIdQuery,
    useLazyGetCurrencyByDealerAddressIdQuery
} = dealerAgreementTypeApi;
